import { Stack, TextField, Typography } from '@mui/material';
import { useDocumentContext } from './DocumentContext';

export default function PageNumberNavigation() {
  const { productMeta } = useDocumentContext();

  // Show the component only if page numbers are available
  if (typeof productMeta?.lastPageNumber !== 'string') {
    return null;
  }

  return (
    <Stack
      direction='row'
      component='form'
      alignItems='center'
      gap={0.5}
      sx={{ flexShrink: 0 }}
    >
      <Typography
        variant='caption'
        component='label'
        id='page-number-navigation-label'
        sx={{ color: 'text.secondary', paddingRight: 0.5 }}
      >
        Sivu
      </Typography>
      <TextField
        size='small'
        value={'1234'}
        variant='standard'
        slotProps={{
          htmlInput: {
            'aria-labelledby': 'page-number-navigation-label',
            sx: {
              lineHeight: (theme) => theme.typography.caption.lineHeight,
              padding: 0,
              paddingRight: 0.5,
              textAlign: 'end',
              color: 'text.primary',
            },
          },
          input: {
            sx: {
              width: '2rem',
              height: '1.5rem',
              lineHeight: '1.5',
              paddingBottom: 0,
              fontSize: (theme) => theme.typography.caption.fontSize,
            },
          },
        }}
      />
      <Typography variant='caption' sx={{ color: 'text.secondary' }}>
        / {productMeta.lastPageNumber}
      </Typography>
    </Stack>
  );
}
